/* eslint-disable*/
import firebase from 'firebase';

const state = {
    user: null,
    signedIn: false,
    signUpModal: false,
    userToken:null,
    hasuraId: null,
    userSignedUp: null
}

const getters = {
    getUser:(state)=>{
        return state.user;
    },
    getSignedIn:(state)=>{
        return state.signedIn;
    },
    getSignUpModal:(state)=>{
        return state.signUpModal;
    },
    getToken:(state)=>{
        return state.userToken;
    },
    getHasuraId:(state)=>{
        return state.hasuraId;
    },
    getUserSignedUp:(state)=>{
        return state.userSignedUp;
    }

}

const actions = {
    async signIn({ commit, dispatch }) {
        var provider = new firebase.auth.TwitterAuthProvider();
        const attempt = await firebase.auth().signInWithPopup(provider).then(res => {
            commit('SET_USER', res);
            dispatch('checkSignIn');
            return true
        }).catch(error => {
            alert(error);
            return false
        })
        return attempt;
    },
    signOut({ commit }) {
        firebase.auth().signOut().then(function () {
            commit('LOGOUT');
        }).catch(function (error) {
            alert(error);
        });

    },
    setSignInState({commit}, data){
        commit('SETSIGNIN', data);
    },
    showSignUpModal({ commit }, show){
        commit('SHOW_MODAL', show);
    },
    setUserSignedUp({commit}, data){
        commit('USER_SIGNED_UP', data);
    },
    checkSignIn({commit}){
        let user = firebase.auth();
        user.onAuthStateChanged(function(user) {
            if (user !== null) {
            return user.getIdToken().then((token) => firebase.auth().currentUser.getIdTokenResult()
            .then((result) => {
              if (result.claims['https://hasura.io/jwt/claims']) {
                  commit('setHasuraId', result.claims['https://hasura.io/jwt/claims'].['x-hasura-user-id'])
                return token
              }
              const endpoint = 'https://us-central1-slow-band-auth.cloudfunctions.net/refreshToken'
              return fetch(`${endpoint}?uid=${user.uid}`).then((res) => {
                if (res.status === 200) {
                  return user.getIdToken(true)
                }
                return res.json().then((e) => { throw e })
              })
            })).then((validToken) => {
                commit('SETTOKEN', validToken);
            // Store Token / Or create Apollo with your new token!
          }).catch(console.error);
        }
        });
    },
    setUnsignedUser({commit}, res){
        commit('SET_USER', res);
    }
}

const mutations = {
    SET_USER (state, payload) {
        state.user = payload;
        return state;
    },
    LOGOUT (state) {
        state.user = null;
        state.signedIn = false;
        return state;
    },
    SHOW_MODAL (state, show) {
        if (show) {
            state.signUpModal = true;
        } else {
            state.signUpModal = false;
        }
    },
    SETTOKEN (state, token) {
        state.userToken = token;
        return state;
    },
    setHasuraId (state, data) {
        state.hasuraId = data;
        return state;
    },
    SETSIGNIN (state, data) {
        state.signedIn = data;
        return state;
    },
    USER_SIGNED_UP (state, data) {
        state.userSignedUp = data;
        return state;
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}